import { createTheme } from '@mui/material/styles';
import {
    BLUE, BLUE_HOVER, BLUE_PRESSED, BLUE_TEXT, BORDER, ERROR, ERROR_SOFT, ERROR_TEXT,
    GREEN, INK, INTER, PAGE_BACKGROUND, POPPINS, SLATE, SOFT_BLUE, SUCCESS_SOFT, SUCCESS_TEXT,
    WARNING, WARNING_SOFT, WARNING_TEXT, YELLOW,
} from './verbaScholaPalette';

// This nested theme deliberately replaces the legacy application's component and
// palette overrides for /teacher and /student while leaving legacy routes unchanged.
const verbaScholaTheme = createTheme({
    palette: {
        primary: { main: BLUE, dark: BLUE_PRESSED },
        secondary: { main: YELLOW, contrastText: INK },
        success: { main: GREEN, dark: SUCCESS_TEXT, light: SUCCESS_SOFT },
        error: { main: ERROR, dark: ERROR_TEXT, light: ERROR_SOFT },
        warning: { main: WARNING, dark: WARNING_TEXT, light: WARNING_SOFT },
        info: { main: BLUE, dark: BLUE_TEXT, light: SOFT_BLUE },
        text: { primary: INK, secondary: SLATE },
        background: { default: PAGE_BACKGROUND, paper: '#FFFFFF' },
        divider: BORDER,
    },
    shape: { borderRadius: 11 },
    typography: {
        fontFamily: INTER,
        h1: { fontFamily: POPPINS, fontWeight: 600, fontSize: '2.25rem' },
        h2: { fontFamily: POPPINS, fontWeight: 600, fontSize: '1.75rem' },
        h3: { fontFamily: POPPINS, fontWeight: 600, fontSize: '1.5rem' },
        h4: { fontFamily: POPPINS, fontWeight: 600, fontSize: '1.25rem' },
        h5: { fontFamily: POPPINS, fontWeight: 600, fontSize: '1.125rem' },
        h6: { fontFamily: POPPINS, fontWeight: 600, fontSize: '1rem' },
        button: { fontFamily: INTER, fontWeight: 700, textTransform: 'none' },
    },
    components: {
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    '&.Mui-focusVisible': { outline: `3px solid ${BLUE}`, outlineOffset: 3 },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 11,
                    fontFamily: INTER,
                    fontWeight: 700,
                    textTransform: 'none',
                    boxShadow: 'none',
                    '&:hover': { boxShadow: 'none' },
                },
                sizeMedium: { minHeight: 44 },
                sizeSmall: { minHeight: 44 },
                textPrimary: { color: BLUE_TEXT },
                outlinedPrimary: { color: BLUE_TEXT },
            },
        },
        MuiIconButton: { styleOverrides: { root: { minWidth: 44, minHeight: 44 } } },
        MuiChip: { styleOverrides: { root: { fontFamily: INTER } } },
        MuiInputBase: { styleOverrides: { root: { fontFamily: INTER } } },
        MuiInputLabel: { styleOverrides: { root: { fontFamily: INTER } } },
        MuiFormHelperText: { styleOverrides: { root: { fontFamily: INTER } } },
        MuiFormControlLabel: { styleOverrides: { label: { fontFamily: INTER } } },
        MuiMenuItem: { styleOverrides: { root: { minHeight: 44, fontFamily: INTER } } },
        MuiTab: { styleOverrides: { root: { minHeight: 44, fontFamily: INTER, textTransform: 'none' } } },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    minHeight: 44,
                    borderRadius: 11,
                    fontFamily: INTER,
                    textTransform: 'none',
                    '&.Mui-selected': {
                        color: BLUE_TEXT,
                        backgroundColor: SOFT_BLUE,
                        '&:hover': { backgroundColor: BLUE_HOVER },
                    },
                },
            },
        },
        MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 11 } } },
        // MUI derives standard Alert colors by lightening palette.light again, which turns
        // the soft tokens near-white with gray text. Use the documented soft/text pairs.
        MuiAlert: {
            styleOverrides: {
                root: { fontFamily: INTER },
                standardSuccess: { backgroundColor: SUCCESS_SOFT, color: SUCCESS_TEXT, '& .MuiAlert-icon': { color: GREEN } },
                standardError: { backgroundColor: ERROR_SOFT, color: ERROR_TEXT, '& .MuiAlert-icon': { color: ERROR_TEXT } },
                standardWarning: { backgroundColor: WARNING_SOFT, color: WARNING_TEXT, '& .MuiAlert-icon': { color: WARNING_TEXT } },
                standardInfo: { backgroundColor: SOFT_BLUE, color: BLUE_TEXT, '& .MuiAlert-icon': { color: BLUE } },
            },
        },
    },
});

export default verbaScholaTheme;
